/**
 * @param {number} quartileNumber 
 * @returns {string}
 */
export function getQuartileName(quartileNumber) {
  switch(quartileNumber) {
    case 1: return 'top_25%';
    case 2: return '25-50%';
    case 3: return '50-75%';
    case 4: return '75-100%';
  }
  throw new Error(`Unknown quartileNumber ${quartileNumber}.`);
}
